export const serverUrl = {
    // '/api',https://fyyun.cqm.cn/api
    baseURL: process.env.NODE_ENV === 'development'?'https://fyyun.cqm.cn/api':'/api',
		uploadUrl: 'https://api.86122m.com/api/file/uploadObjectOSS',
    imgUrl: 'https://mzmpic.oss-cn-beijing.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js